export type ExpertModeTheme = {
    colors: {
        primary: string;
        primaryLight: string;
        secondary: string;
        text: string;
        textLight: string;
        textVeryLight: string;
        textHighlight : string;
        highlight : string;
        subtle: string;
        mediumSubtle: string;
        superSubtle: string;
    };
};

export const defaultExpertModeTheme: ExpertModeTheme = {
    colors: {
        primary: "#00666B",
        primaryLight: "#E4EBED",
        secondary: "#252731",
        text : "#131313",
        textLight : "#131313B3",
        textVeryLight: "#71717A",
        textHighlight : "#FFFFFF",
        highlight : "#FFFFFF",
        subtle: "#E4E4E7",
        mediumSubtle: "#F4F4F5",
        superSubtle: "#FDFDFD"
    },
};

